import { render, staticRenderFns } from "./SocialSummaryControls.vue?vue&type=template&id=30469a9c&"
import script from "./SocialSummaryControls.vue?vue&type=script&lang=js&"
export * from "./SocialSummaryControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30469a9c')) {
      api.createRecord('30469a9c', component.options)
    } else {
      api.reload('30469a9c', component.options)
    }
    module.hot.accept("./SocialSummaryControls.vue?vue&type=template&id=30469a9c&", function () {
      api.rerender('30469a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialSummaryControls.vue"
export default component.exports